module.exports = __webpack_public_path__ + "static/media/youtube-grey.7a1b8e49.svg";